<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">设备添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="房间" required prop="roomCode" style="width:100%">
                                    <el-cascader
                                        ref="cascader"
                                        v-model="addForm.roomCode"
                                        placeholder="请选择房间"
                                        @change="changeRoom"
                                        :options="options" :props="props" style="width:100%"></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="设备名称" required prop="name">
                                    <el-input v-model="addForm.name" placeholder="请输入设备名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="设备序列号" required prop="gatewayId">
                                    <el-input v-model="addForm.gatewayId" placeholder="请输入设备序列号"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getToken,getStaffCode} from "@/utils/auth";
    

    export default {
        props: ["options"],
        name: 'Add',
        data() {
            return {
                loading: false,
                floor:null,
                obj:null,
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    buildingCode:'',
                    buildingName:'',
                    roomCode:'',
                    roomName:'',
                    loginName:'',
                    plateform:'institution',
                    organizationCode:'',
                    name:'',
                    gatewayId:'',
                },
                roomCodeList:[],
                rules:{
                    name:[
                        { required: true, message: '请输入设备名称', trigger: 'blur' },
                    ],
                    roomCode:[
                        { required: true, message: '请选择房间', trigger: 'blur' },
                    ],
                    gatewayId:[
                        { required: true, message: '请输入设备序列号', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();
                this.addForm.roomCode=''
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            changeRoom(value){
                console.log(value);
                //查看选择的整条数据
                let obj = this.$refs["cascader"].getCheckedNodes();
                this.obj = obj[0].data;
                
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                var token =  JSON.parse(getToken());
                this.addForm.loginName = token.loginName;
                this.addForm.organizationCode = token.institutionCode;
                this.addForm.buildingCode = this.obj.buildingCode;
                this.addForm.buildingName = this.obj.buildingName;
                this.addForm.roomCode = this.obj.value;
                this.addForm.roomName = this.obj.label;
                this.$axios({
                    method: 'post',
                    url: this.$deviceUrl+"YJGateway/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 800px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
